<template>
  <div>
    <Row :gutter="10" align="middle">
      <Col span="3">最新进度:</Col>
      <Col span="21">
        <RadioGroup
          v-model="button"
          @on-change="change(button)"
          type="button"
          size="default"
          v-for="(item, index) in btnList"
          :key="index"
        >
          <Radio :label="item.id">{{ item.junctionName }}</Radio>
        </RadioGroup>
      </Col>
    </Row>
    <Row :gutter="10" style="margin-top: 20px">
      <Col span="3">进度编写:</Col>
      <Col span="21">
        <formEditor v-model="desc"></formEditor>
      </Col>
    </Row>
    <Row :gutter="10" style="margin-top: 20px" align="middle">
      <Col span="3">创建时间:</Col>
      <Col span="21">
        <DatePicker
          type="datetime"
          placeholder="请选择时间"
          style="width: 200px"
          v-model="fillingTime"
          format="yyyy年MM月dd日 HH:mm"
          @on-change="handleChange"
        />
      </Col>
    </Row>
    <Row :gutter="10" style="margin-top: 20px" align="middle">
      <Col span="3">附件:</Col>
      <Col span="21">
        <uploadFile2 type="document" v-model="remarkUrl"></uploadFile2>
      </Col>
    </Row>
    <div style="margin-top: 20px">
      <Button type="primary" @click="onSubmit">保存</Button>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import uploadFile2 from "@/views/components/common/form/uploadFile2.vue";
import formEditor from "@/views/components/common/form/formEditor.vue";
export default {
  components: {
    uploadFile2,
    formEditor,
  },
  props: { id: "", data: {}, Edit: "" },
  data() {
    return {
      button: "",
      desc: "",
      remarkUrl: "",
      btnList: [],
      schedule: Number(""),
      projectId: window.localStorage.getItem("projectId"),
      isEdit: "",
      fillingTime: "",
      editId: "",
      fillingTime: dayjs().format("YYYY年MM月DD日 HH:mm"),
    };
  },
  created() {
    if (this.Edit == "edit") {
      this.getschedule(this.id);
      this.button = this.data.schedule;
      this.schedule = this.data.schedule;
      this.desc = this.data.content;
      this.remarkUrl = this.data.remarkUrl;
      this.fillingTime = this.data.fillingTime;
      this.isEdit = "edit";
      this.editId = this.data.id;
    } else if (this.Edit == "add") {
      this.getschedule(this.id);
      this.button = this.data.schedule;
      this.schedule = this.data.schedule;
      this.isEdit = "";
    } else {
      this.getschedule(this.id);
    }
  },
  methods: {
    handleChange(val) {
      this.fillingTime = val;
    },
    async getschedule(id) {
      let res = await $utils.api.load(`/admin/system/schedule/${id}`);
      try {
        if (res.code == 200) {
          let list = res.data.sysProjectScheduleStateList || [];
          this.btnList = list;
        }
      } catch (e) {
        console.log(e);
      }
    },
    change(item) {
      this.schedule = item;
    },
    async onSubmit() {
      if (!this.schedule) {
        $utils.toast.error("请选择最新进度");
        return;
      }
      let q = {
        remarkUrl: this.remarkUrl,
        content: this.desc,
        projectId: this.projectId,
        schedule: this.schedule,
        fillingTime: this.fillingTime,
      };
      if (this.isEdit) {
        q.id = this.editId;
      }
      this.loading = true;
      $utils.api
        .load("/admin/system/activity", q, this.isEdit == "edit" ? "put" : "POST")
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            $utils.toast.success("保存成功");
            location.reload();
          }
        });
    },
  },
};
</script>
